var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { call, put, takeLatest, fork } from 'redux-saga/effects';
import * as A from './actions';
import { XbpmContext } from '../../services';
import { loadFormSuccessTask } from '../forms/sagas';
import { omit } from 'ramda';
function bpmProcessSuccessResultTask(result) {
    var navService, processInstanceId, taskDefinitionKey;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                navService = XbpmContext.getContext().navService;
                if (!!result) return [3 /*break*/, 1];
                navService.home(true);
                return [3 /*break*/, 3];
            case 1:
                processInstanceId = result.processInstanceId, taskDefinitionKey = result.taskDefinitionKey;
                return [4 /*yield*/, fork(loadFormSuccessTask, processInstanceId, taskDefinitionKey, result)];
            case 2:
                _a.sent();
                navService.navigate({
                    $kind: 'task',
                    processInstanceId: processInstanceId,
                    taskDefinitionKey: taskDefinitionKey,
                }, true);
                _a.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
function bpmnProcessesWorker(_a) {
    var apiService, params, items, error_1;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                params = payload.params;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(apiService.loadProcesses, params)];
            case 2:
                items = _b.sent();
                return [4 /*yield*/, put(A.fetchProcessesSuccessAction({ items: items }))];
            case 3:
                _b.sent();
                return [3 /*break*/, 6];
            case 4:
                error_1 = _b.sent();
                return [4 /*yield*/, put(A.fetchProcessesErrorAction({ error: error_1 }))];
            case 5:
                _b.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function bpmnProcessByIdWorker(_a) {
    var apiService, processDefinitionId, result, error_2;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                processDefinitionId = payload.processDefinitionId;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(apiService.startProcessById, processDefinitionId)];
            case 2:
                result = _b.sent();
                return [4 /*yield*/, fork(bpmProcessSuccessResultTask, result)];
            case 3:
                _b.sent();
                return [4 /*yield*/, put(A.startProcessByIdSuccessAction())];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                error_2 = _b.sent();
                return [4 /*yield*/, put(A.startProcessByIdErrorAction({ error: error_2 }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function bpmnProcessByKeyWorker(_a) {
    var _b, apiService, storeNavigationParams, processDefinitionKey, etc, result, error_3;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = XbpmContext.getContext(), apiService = _b.apiService, storeNavigationParams = _b.storeNavigationParams;
                processDefinitionKey = payload.processDefinitionKey, etc = __rest(payload, ["processDefinitionKey"]);
                storeNavigationParams(payload);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(apiService.startProcessByKey, processDefinitionKey, omit(['$kind'], etc))];
            case 2:
                result = _c.sent();
                return [4 /*yield*/, fork(bpmProcessSuccessResultTask, result)];
            case 3:
                _c.sent();
                return [4 /*yield*/, put(A.startProcessByKeySuccessAction())];
            case 4:
                _c.sent();
                return [3 /*break*/, 7];
            case 5:
                error_3 = _c.sent();
                return [4 /*yield*/, put(A.startProcessByKeyErrorAction({ error: error_3 }))];
            case 6:
                _c.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function bpmnProcessByAppWorker(_a) {
    var _b, apiService, storeNavigationParams, applicationGroup, applicationCode, applicationVersion, force, result, error_4;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = XbpmContext.getContext(), apiService = _b.apiService, storeNavigationParams = _b.storeNavigationParams;
                applicationGroup = payload.applicationGroup, applicationCode = payload.applicationCode, applicationVersion = payload.applicationVersion, force = payload.force;
                storeNavigationParams(payload);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(apiService.startProcessByApp, { applicationGroup: applicationGroup, applicationCode: applicationCode, applicationVersion: applicationVersion }, force)];
            case 2:
                result = _c.sent();
                return [4 /*yield*/, fork(bpmProcessSuccessResultTask, result)];
            case 3:
                _c.sent();
                return [4 /*yield*/, put(A.startProcessByAppSuccessAction())];
            case 4:
                _c.sent();
                return [3 /*break*/, 7];
            case 5:
                error_4 = _c.sent();
                return [4 /*yield*/, put(A.startProcessByAppErrorAction({ error: error_4 }))];
            case 6:
                _c.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
export default (function () { return [
    takeLatest(A.LOAD_PROCESSES, bpmnProcessesWorker),
    takeLatest(A.START_PROCESS_BY_ID, bpmnProcessByIdWorker),
    takeLatest(A.START_PROCESS_BY_KEY, bpmnProcessByKeyWorker),
    takeLatest(A.START_PROCESS_BY_APP, bpmnProcessByAppWorker),
]; });
//# sourceMappingURL=sagas.js.map